import { createSelector } from 'reselect';
import { prop } from 'ramda';

import { BUTTONS } from '../enums';

export const getSettings = prop('settings');

export const getSplashScreen = createSelector(getSettings, prop('SPLASH_SCREEN'));

export const getUserDataEligibilityPdf = createSelector(getSettings, prop('USER_DATA_ELIGIBILITY_PDF'));

export const getAppointmentDeactivation = createSelector(getSettings, prop('APPOINTMENT_DEACTIVATION'));

export const getFnolWorkflow = createSelector(getSettings, prop('FNOL_WORKFLOW'));

export const getIsPublicApiV4 = createSelector(
  getSettings,
  settings =>
    // eslint-disable-next-line camelcase
    settings?.PUBLIC_APIv4_ACTIVATION === true || settings?.PUBLIC_API_V4_ACTIVATION === true
);

export const getIsPublicApiV5 = createSelector(
  getSettings,
  settings =>
    // eslint-disable-next-line camelcase
    settings?.PUBLIC_APIv5_ACTIVATION === true || settings?.PUBLIC_API_V5_ACTIVATION === true
);

export const getIsDownsized = createSelector(getSettings, prop('EMBEDDED_WEBAPP_DOWNSIZE'));

export const getEvents = createSelector(getSettings, prop('EVENTS'));

export const getEventTypes = createSelector(getSettings, settings => settings?.EVENT_TYPES ?? []);

export const getAdditionalTransportationQuestion = createSelector(getSettings, prop('ADDITIONAL_TRANSPORTATION_QUESTION'));

export const getIsOemWorkflowEnabled = createSelector(getSettings, prop('OEM_WORKFLOW'));

export const getActivateGA4 = createSelector(getSettings, prop('ACTIVATE_GA4'));

export const getDisplayCustomDestinationFrist = createSelector(getSettings, prop('DISPLAY_CUSTOM_DESTINATION_FIRST'));

export const getDisplayNetworkGarageContext = createSelector(getSettings, prop('DISPLAY_NETWORK_GARAGES_CONTEXT'));

export const getImpressumUrl = createSelector(getSettings, prop('IMPRESSUM_URL'));

export const getDisplayMileage = createSelector(getSettings, prop('ELIGIBILITYCHECK_MILEAGE_DISPLAYED'));

export const getDisplayVinNumber = createSelector(getSettings, prop('ELIGIBILITYCHECK_CAR_VIN_DISPLAYED'));

export const getDisplayPlateNumber = createSelector(getSettings, settings => settings?.ELIGIBILITYCHECK_CAR_PLATE_DISPLAYED ?? true);

export const isVinMandatory = createSelector(getSettings, prop('VIN_MANDATORY'));

export const getDisplayLeaserContractNumber = createSelector(getSettings, prop('ELIGIBILITYCHECK_LEASER_CONTRACT_NUMBER_DISPLAYED'));

export const getRentalCarDisplayPlateNumber = createSelector(
  getSettings,
  settings => settings?.RENTAL_WORKFLOW?.RENTAL_CAR_PLATE_DISPLAYED
);

export const getRentalCarDisplayVinNumber = createSelector(getSettings, settings => settings?.RENTAL_WORKFLOW?.RENTAL_CAR_VIN_DISPLAYED);

export const getRentalCarPhoneRequired = createSelector(
  getSettings,
  settings => settings?.RENTAL_WORKFLOW?.RENTAL_CAR_OTHER_LOCATION_PHONE_REQUIRED
);

export const getRentalCarExtensionPopupEnabled = createSelector(
  getSettings,
  settings => settings?.RENTAL_WORKFLOW?.RENTAL_EXTENSION_END_POPUP_ENABLED
);

// Button visibility selectors

const createButtonVisibilitySelector = buttonKey => createSelector(getSettings, settings => settings?.BUTTONS?.[buttonKey] !== false);

export const getButtonVisibleRentalExtensionTimeline = createSelector(
  getSettings,
  settings => settings?.BUTTONS?.[BUTTONS.RENTAL_EXTENSION_TIMELINE_VISIBLE]
);
export const getButtonVisibleRentalExtensionSummary = createSelector(
  getSettings,
  settings => settings?.BUTTONS?.[BUTTONS.RENTAL_EXTENSION_SUMMARY_VISIBLE]
);
export const getButtonVisibleErrorPageCallAssistance = createButtonVisibilitySelector(BUTTONS.ERROR_PAGE_CALL_ASSISTANCE_VISIBLE);

//

export const getSubscriptionEligibilityWrongDataWorkflow = createSelector(
  getSettings,
  settings => settings?.SUBSCRIPTION_ELIGIBILITY_WRONG_DATA_WORKFLOW
);

export const getSubscriptionEligibilityNotCoveredOrExceededWorkflow = createSelector(
  getSettings,
  settings => settings?.SUBSCRIPTION_ELIGIBILITY_NOT_COVERED_OR_EXCEEDED_WORKFLOW
);

export const getAssistancePhoneNumber = createSelector(getSettings, settings => settings?.ASSISTANCE_PHONE_NUMBER);
